import React, {Component} from 'react';
import FilterInput from "../../inputs/filterInput/FilterInput";
import Card from "../../components/card/Card";
import PrimaryButton from "../../components/primaryButton/PrimaryButton";
import formFilters from "../../utils/formFilters";
import HeaderRow from '../../components/headerRow/HeaderRow';
import Row from '../../components/row/Row';
import Label from '../../components/label/Label';
import Volume from '../../components/volume/Volume';
import Input from '../../inputs/input/Input';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import mainAPI from '../../api/MainAPI';
import utils from '../../utils/utils';
import models from '../../model/models';
import './Dea41Export.css';

const US_STATES = {
	'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California',
	'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'FL': 'Florida', 'GA': 'Georgia',
	'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa',
	'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
	'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri',
	'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey',
	'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio',
	'OK': 'Oklahoma', 'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
	'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont',
	'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming'
};

export default class Dea41Export extends Component {
	constructor(props) {
		super(props);
		const defaultFilter = formFilters.defaultFilter('dea41');
		const today = new Date();
		const formattedToday = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

		this.state = {
			filter: this._getFilterValue(defaultFilter),
			wasteRecords: [],
			loadingWasteRecords: false,
			showForm: false,
			pendingDownload: null,
			user_group_detail_id: null,
			registered_name: '',
			dea_registration_number: '',
			registered_address: '',
			registered_city: '',
			registered_state: '',
			registered_zip_code: '',
			registered_telephone_number: '',
			registered_contact_name: '',
			destruction_date: formattedToday,
			destruction_method: '',
			destruction_location_or_business_name: '',
			destruction_address: '',
			destruction_city: '',
			destruction_state: '',
			destruction_zip_code: ''
		};
	}

	_getFilterValue = (currentFilter) => {
		if (!currentFilter || !Array.isArray(currentFilter)) return null;
		const value = {};
		for (let i in currentFilter) {
			const column = currentFilter[i].column;
			if (!value[column]) value[column] = { values: [] };
			value[column].values.push(currentFilter[i].value);
		}
		return value;
	}

	componentDidMount = () => {
		this._fetchWasteRecords();
		this._loadUserGroupDetails();
		this.userGroupSubId = models.user_group.onChange(this._setAgencyName);
	};

	componentWillUnmount = () => {
		if (this.userGroupSubId) {
			models.user_group.unsubscribe(this.userGroupSubId);
		}
	};

	_setAgencyName = () => {
		const userGroup = models.user_group.obj();
		if (userGroup && userGroup.name && !this.state.registered_name) {
			this.setState({ registered_name: userGroup.name });
		}
	};

	_loadUserGroupDetails = async () => {
		try {
			const allDetails = await mainAPI.user_group_detail.all();
			const details = Array.isArray(allDetails) && allDetails.length > 0 ? allDetails[0] : null;
			if (details) {
				const userGroup = models.user_group.obj();
				this.setState({
					user_group_detail_id: details.id || null,
					registered_name: details.registered_name || (userGroup && userGroup.name) || '',
					dea_registration_number: details.dea_registration_number || '',
					registered_address: details.registered_address || '',
					registered_city: details.registered_city || '',
					registered_state: details.registered_state || '',
					registered_zip_code: details.registered_zip_code || '',
					registered_telephone_number: details.registered_telephone_number || '',
					registered_contact_name: details.registered_contact_name || '',
					destruction_method: details.destruction_method || '',
					destruction_location_or_business_name: details.destruction_location_or_business_name || '',
					destruction_address: details.destruction_address || '',
					destruction_city: details.destruction_city || '',
					destruction_state: details.destruction_state || '',
					destruction_zip_code: details.destruction_zip_code || ''
				});
			} else {
				this._setAgencyName();
			}
		} catch (error) {
			console.error('Error loading user group details:', error);
			this._setAgencyName();
		}
	};

	_handleInputChange = (field, value) => {
		this.setState({ [field]: value });
	};

	_saveUserGroupDetails = async () => {
		const {
			user_group_detail_id,
			registered_name,
			dea_registration_number,
			registered_address,
			registered_city,
			registered_state,
			registered_zip_code,
			registered_telephone_number,
			registered_contact_name,
			destruction_method,
			destruction_location_or_business_name,
			destruction_address,
			destruction_city,
			destruction_state,
			destruction_zip_code
		} = this.state;

		const data = {
			registered_name,
			dea_registration_number,
			registered_address,
			registered_city,
			registered_state,
			registered_zip_code,
			registered_telephone_number,
			registered_contact_name,
			destruction_method,
			destruction_location_or_business_name,
			destruction_address,
			destruction_city,
			destruction_state,
			destruction_zip_code
		};

		try {
			let response;
			if (user_group_detail_id) {
				response = await mainAPI.user_group_detail.update({ id: user_group_detail_id, ...data });
			} else {
				response = await mainAPI.user_group_detail.create(data);
				if (response && response.id) {
					this.setState({ user_group_detail_id: response.id });
				}
			}
		} catch (error) {
			console.error('Error saving user group details:', error);
		}
	};

	_handleFilterChange = (filter) => {
		for (let i in filter){
		  for (let j in filter[i].values) {
				if(filter[i].values[j].datetime && filter[i].values[j].datetime.toISOString){
					filter[i].values[j].datetime = filter[i].values[j].datetime.toISOString();
				}
			}
		}
		this.setState({ filter }, () => {
			this._fetchWasteRecords();
		});
	};

	_getDateKey = (dateString) => {
		if (!dateString) return '';
		const clientDate = utils.server_to_client_datetime(dateString);
		const year = clientDate.getFullYear();
		const month = String(clientDate.getMonth() + 1).padStart(2, '0');
		const day = String(clientDate.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	};

	_getWitnessKey = (record) => {
		const createdById = record.created_by_id || 'null';
		const witnessId = record.witness_id || 'null';
		const guestVerifyId = record.guest_verify_id || 'null';
		return `${createdById}_${witnessId}_${guestVerifyId}`;
	};

	_groupRecordsByDateAndWitnesses = (records) => {
		const grouped = {};
		records.forEach((record) => {
			const dateKey = this._getDateKey(record.created_on);
			const witnessKey = this._getWitnessKey(record);

			if (!grouped[dateKey]) {
				grouped[dateKey] = {};
			}
			if (!grouped[dateKey][witnessKey]) {
				grouped[dateKey][witnessKey] = [];
			}
			grouped[dateKey][witnessKey].push(record);
		});
		return grouped;
	};

	_downloadForDate = (dateString, recordIds) => {
		this.setState({
			showForm: true,
			pendingDownload: { dateString, recordIds }
		});
	};

	_confirmDownload = async () => {
		const { pendingDownload } = this.state;
		if (!pendingDownload) return;

		await this._saveUserGroupDetails();
		this._downloadPdf(pendingDownload.dateString, pendingDownload.recordIds);
		this.setState({ showForm: false, pendingDownload: null });
	};

	_cancelDownload = () => {
		this.setState({ showForm: false, pendingDownload: null });
	};

	_downloadPdf = (dateString, recordIds) => {
		const queryParams = new URLSearchParams();

		if (recordIds && recordIds.length > 0) {
			queryParams.append('record_ids', JSON.stringify(recordIds));
		} else {
			const date = new Date(dateString);
			const startOfDay = new Date(date);
			startOfDay.setHours(0, 0, 0, 0);
			const endOfDay = new Date(date);
			endOfDay.setHours(23, 59, 59, 999);

			const afterTimestamp = startOfDay.getTime().toString();
			const beforeTimestamp = endOfDay.getTime().toString();

			queryParams.append('after_timestamp', afterTimestamp);
			queryParams.append('before_timestamp', beforeTimestamp);
		}

		const url = `/api/v1/form/Dea41?${queryParams.toString()}`;

		const {
			registered_name,
			dea_registration_number,
			registered_address,
			registered_city,
			registered_state,
			registered_zip_code,
			registered_telephone_number,
			registered_contact_name,
			destruction_date,
			destruction_method,
			destruction_location_or_business_name,
			destruction_address,
			destruction_city,
			destruction_state,
			destruction_zip_code
		} = this.state;

		const body = {
			registered_name,
			dea_registration_number,
			registered_address,
			registered_city,
			registered_state,
			registered_zip_code,
			registered_telephone_number,
			registered_contact_name,
			destruction_date,
			destruction_method,
			destruction_location_or_business_name,
			destruction_address,
			destruction_city,
			destruction_state,
			destruction_zip_code
		};

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-auth-token': localStorage.token,
				'user-group-id': localStorage.user_group_id || '',
				'x-user-group-id': localStorage.user_group_id || '',
				'x-region': localStorage.region || '',
				'x-admin-version': (localStorage['x-admin-version'] || ''),
				'last-log-in': localStorage.last_log_in || '',
			},
			body: JSON.stringify(body),
		})
			.then(response => {
				if (!response.ok) throw new Error('Network response was not ok');
				return response.blob();
			})
			.then(blob => {
				const dateStr = this._getDateKey(dateString);
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `DEA-41-${dateStr}.pdf`);
				document.body.appendChild(link);
				link.click();
				link.parentNode.removeChild(link);
				window.URL.revokeObjectURL(url);
			})
			.catch(error => {
				console.error('Error downloading DEA-41 PDF:', error);
			});
	};

	_fetchWasteRecords = async () => {
		const { filter } = this.state;

		this.setState({ loadingWasteRecords: true });

		let afterTimestamp = null;
		let beforeTimestamp = null;

		if (filter && filter.created_on && filter.created_on.values) {
			filter.created_on.values.forEach((value) => {
				if (value.operator === '>') {
					afterTimestamp = new Date(value.datetime).getTime();
				} else if (value.operator === '<') {
					beforeTimestamp = new Date(value.datetime).getTime();
				}
			});
		}

		try {
			const wasteRecords = await mainAPI.stock_move_record.wasted(
				afterTimestamp,
				beforeTimestamp,
				null,
				{}
			);
			this.setState({ wasteRecords: wasteRecords || [], loadingWasteRecords: false });
		} catch (error) {
			console.error('Error fetching waste records:', error);
			this.setState({ wasteRecords: [], loadingWasteRecords: false });
		}
	};

	renderForm = () => {
		const {
			registered_name,
			dea_registration_number,
			registered_address,
			registered_city,
			registered_state,
			registered_zip_code,
			registered_telephone_number,
			registered_contact_name,
			destruction_date,
			destruction_method,
			destruction_location_or_business_name,
			destruction_address,
			destruction_city,
			destruction_state,
			destruction_zip_code
		} = this.state;

		return (
			<div className="g-dea41-form-export">
				<div className="g-dea41-form-export-header">
					<Label black bold large>Additional Information</Label>
				</div>
				<div className="g-dea41-form-export-section">
					<Label black bold className="section-title">Registrant Information</Label>
					<div className="form-row">
						<Input
							placeholder="Registered Name"
							value={registered_name}
							onChange={(value) => this._handleInputChange('registered_name', value)}
						/>
						<Input
							placeholder="DEA Registration Number"
							value={dea_registration_number}
							onChange={(value) => this._handleInputChange('dea_registration_number', value)}
						/>
					</div>
					<div className="form-row">
						<Input
							placeholder="Registered Address"
							value={registered_address}
							onChange={(value) => this._handleInputChange('registered_address', value)}
							className="full-width"
						/>
					</div>
					<div className="form-row">
						<Input
							placeholder="City"
							value={registered_city}
							onChange={(value) => this._handleInputChange('registered_city', value)}
						/>
						<UniversalDropDown
							key={'registered_state_' + registered_state}
							placeholder="State"
							value={registered_state}
							options={US_STATES}
							onChange={(value) => this._handleInputChange('registered_state', value)}
							className="small"
						/>
						<Input
							placeholder="Zip Code"
							value={registered_zip_code}
							onChange={(value) => this._handleInputChange('registered_zip_code', value)}
							className="small"
						/>
					</div>
					<div className="form-row">
						<Input
							placeholder="Telephone Number"
							value={registered_telephone_number}
							onChange={(value) => this._handleInputChange('registered_telephone_number', value)}
						/>
						<Input
							placeholder="Contact Name"
							value={registered_contact_name}
							onChange={(value) => this._handleInputChange('registered_contact_name', value)}
						/>
					</div>
				</div>

				<div className="g-dea41-form-export-section">
					<Label black bold className="section-title">Method of Destruction</Label>
					<div className="form-row">
						<Input
							type="date"
							placeholder="Date of Destruction"
							value={destruction_date}
							onChange={(value) => this._handleInputChange('destruction_date', value)}
						/>
						<Input
							placeholder="Method of Destruction"
							value={destruction_method}
							onChange={(value) => this._handleInputChange('destruction_method', value)}
						/>
					</div>
					<div className="form-row">
						<Input
							placeholder="Location or Business Name"
							value={destruction_location_or_business_name}
							onChange={(value) => this._handleInputChange('destruction_location_or_business_name', value)}
							className="full-width"
						/>
					</div>
					<div className="form-row">
						<Input
							placeholder="Address"
							value={destruction_address}
							onChange={(value) => this._handleInputChange('destruction_address', value)}
							className="full-width"
						/>
					</div>
					<div className="form-row">
						<Input
							placeholder="City"
							value={destruction_city}
							onChange={(value) => this._handleInputChange('destruction_city', value)}
						/>
						<UniversalDropDown
							key={'destruction_state_' + destruction_state}
							placeholder="State"
							value={destruction_state}
							options={US_STATES}
							onChange={(value) => this._handleInputChange('destruction_state', value)}
							className="small"
						/>
						<Input
							placeholder="Zip Code"
							value={destruction_zip_code}
							onChange={(value) => this._handleInputChange('destruction_zip_code', value)}
							className="small"
						/>
					</div>
				</div>

				<div className="g-dea41-form-export-actions">
					<PrimaryButton className="back" onClick={this._cancelDownload}>
						Back
					</PrimaryButton>
					<PrimaryButton onClick={this._confirmDownload}>
						Generate Report
					</PrimaryButton>
				</div>
			</div>
		);
	};

	renderWastePreview = () => {
		const { wasteRecords, loadingWasteRecords } = this.state;

		const columns = [
			{ label: 'Type' },
			{ label: 'Code' },
			{ label: 'Strength' },
			{ label: 'NDC Code' },
			{ label: 'Lot Number' },
			{ label: 'Date' },
			{ label: 'Wasted By' },
			{ label: 'Waste Reason' },
			{ label: 'Verified By' }
		];

		const groupedRecords = this._groupRecordsByDateAndWitnesses(wasteRecords);
		const sortedDates = Object.keys(groupedRecords).sort().reverse();

		return (
			<>
				<div className="g-dea41-export">
					<Label black bold className="preview-title">
						Waste Records Preview ({wasteRecords.length} {wasteRecords.length === 1 ? 'record' : 'records'})
					</Label>
					{loadingWasteRecords ? (
						<Label>Loading...</Label>
					) : wasteRecords.length === 0 ? (
						<Label>No waste records found for the selected date range.</Label>
					) : (
						<>
							{sortedDates.map((dateKey) => {
								const witnessGroups = groupedRecords[dateKey];
								const witnessKeys = Object.keys(witnessGroups).sort();
								const [year, month, day] = dateKey.split('-').map(Number);
								const dateObj = new Date(year, month - 1, day);
								const displayDate = utils.display_actual_date(dateObj);
								const totalRecords = Object.values(witnessGroups).reduce((sum, records) => sum + records.length, 0);

								return (
									<div key={dateKey} className="date-group">
										<div className="date-header">
											<Label black bold>{displayDate} ({totalRecords} {totalRecords === 1 ? 'record' : 'records'})</Label>
										</div>
										{witnessKeys.map((witnessKey) => {
											const recordsForWitness = witnessGroups[witnessKey];
											const recordIds = recordsForWitness.map(record => record.id);

											return (
												<div key={witnessKey} className="witness-group">
													<div className="witness-header">
														<PrimaryButton
															className={'export'}
															onClick={() => this._downloadForDate(dateKey, recordIds)}
														>
															Download Report
														</PrimaryButton>
													</div>
													<HeaderRow columns={columns} />
													{recordsForWitness.map((record) => {
														const drugType = models.drug_type.obj(record.type);
														const drugTypeName = drugType ? drugType.name : record.type;

														return (
															<Row key={record.id}>
																<Label>{drugTypeName}</Label>
																<Label>{record.barcode_id || ''}</Label>
																<Label>
																	<Volume value={Math.abs(parseFloat(record.quantity || 0))} type={record.type} />
																</Label>
																<Label>{record.drug__ndc_barcode || ''}</Label>
																<Label>{record.lot_number || ''}</Label>
																<Label>{record.created_on ? utils.display_actual_datetime(record.created_on) : ''}</Label>
																<Label>{record.user_name || ''}</Label>
																<Label>{record.notes || ''}</Label>
																<Label>{record.witness_name || ''}</Label>
															</Row>
														);
													})}
												</div>
											);
										})}
									</div>
								);
							})}
						</>
					)}
				</div>
			</>
		);
	};

	render() {
		const { showForm } = this.state;

		if (showForm) {
			return (
				<Card className={'g-form-details'}>
					{this.renderForm()}
				</Card>
			);
		}

		return (
			<Card>
				<FilterInput
					onChange={this._handleFilterChange}
					currentFilter={formFilters.defaultFilter('dea41')}
					options={formFilters.options('dea41')}
				/>
				{this.renderWastePreview()}
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/formExportPage/Dea41Export.jsx